var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDablArr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04001 0.379989C4.88001 0.539989 1.73 3.98997 0.770004 5.04997C0.400004 5.45997 0.430011 6.08998 0.840011 6.45998C1.25001 6.82998 1.88 6.79997 2.25 6.38997C3.09 5.46997 4.15 4.30999 5 3.37999L5 16.56C3.82 15.32 2.41 13.85 2.41 13.85C2.03 13.45 1.4 13.44 1 13.82C0.6 14.2 0.590001 14.83 0.970001 15.23C2.21 16.53 5.11001 19.56 5.18001 19.63C5.39001 19.84 5.66001 19.96 5.95001 19.99C6.32001 20.02 6.68001 19.89 6.95001 19.61C7.10001 19.46 10.13 16.14 11.05 15.12C11.22 14.93 11.31 14.69 11.31 14.45C11.31 14.18 11.2 13.91 10.98 13.71C10.57 13.34 9.94001 13.37 9.57001 13.78C8.79001 14.64 7.8 15.72 7 16.6L7 3.42998C8.24 4.72998 9.76001 6.31999 9.76001 6.31999C10.14 6.71999 10.77 6.72999 11.17 6.34999C11.38 6.14999 11.48 5.88999 11.48 5.62999C11.48 5.37999 11.39 5.12999 11.2 4.93999C9.91001 3.58999 6.89001 0.42997 6.82001 0.35997C6.38001 -0.0700305 5.60001 -0.180031 5.04001 0.389969L5.04001 0.379989Z",
    fill: "#4D4D4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDablArr);
export default __webpack_public_path__ + "static/media/dablArr.56b33e55503f0f770b9640cd5e97afbb.svg";
export { ForwardRef as ReactComponent };